export default __webpack_public_path__ + "static/media/plain-sticker-B.384ad5b1.png";